import"react";import{isBrowser as t}from"./misc/util.js";var e=function(t){var e=window.history,r=e[t];e[t]=function(e){var a=r.apply(this,arguments),i=new Event(t.toLowerCase());return i.state=e,window.dispatchEvent(i),a}};t&&(e("pushState"),e("replaceState"));
//# sourceMappingURL=useLocation.js.map
